var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('FormItem',{attrs:{"label":"优惠券"}},[_c('coupon-select',{on:{"on-change":_vm.couponSelectChange}})],1),_c('FormItem',[_c('coupon-table',{attrs:{"data":_vm.value.coupons,"showQuantity":true}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }